export const Colors =
{
    mainBlue: '#2863ad'
}